/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
const e="20250318",a="878eb8750809e56d2a9ea9f1475c9e4e58226dad";export{e as buildDate,a as commitHash};
